import { apiClient } from "../../../lib";

export const jeopardyApi = {

    fetchJeopardyCount: async (): Promise<any> => {
        const response = await apiClient.get(`/jeopardy/severity-count`);
        return response.data;
    },

    fetchJeopardyTree: async (selectedFilterCode: string | null): Promise<any> => {
        const response = await apiClient.get(`/jeopardy/jeopardy-tree`, {
            params: {
                filter_code: selectedFilterCode,
            },
        });
        return response.data;
    },

    fetchJeopardy: async (params: { page?: number, limit?: number, filter_code?: string[] | null, projectId?: string }): Promise<any> => {
        const { page, limit, filter_code, projectId } = params;
        const searchParams = new URLSearchParams();
        (filter_code || []).forEach(value => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append('filter_code', String(v));
                });
            } else if (value) {
                searchParams.append('filter_code', String(value));
            }
        });
        if (page) {
            searchParams.append("page", String(page));
        }
        if (limit) {
            searchParams.append("limit", String(limit));
        }
        if (projectId) {
            searchParams.append("project_id", projectId);
        }
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/jeopardy?${queryString}`);
        return response.data;
    },

    fetchJeopardyDetails: async (jeopardyID: string | undefined): Promise<any> => {
        const response = await apiClient.get(`/jeopardy/${jeopardyID}`);
        return response.data;
    },

    updateAccountablePersons: async ({ jeopardyId, payload }: { jeopardyId: any; payload: any }): Promise<any> => {
        const response = await apiClient.put(`/jeopardy/${jeopardyId}/assign-to`, payload);
        return response.data;
    },

    updateTasks: async ({ jeopardyId, payload }: {
        jeopardyId: string;
        payload: {
            "notes": string;
            "jeopardy_tasks": [
                {
                    "task_id": string;
                    "value": boolean;
                }
            ]
        }
    }): Promise<any> => {
        const response = await apiClient.post(`/jeopardy/${jeopardyId}`, payload);
        return response.data;
    },

    updateMarkAsRead: async ({ jeopardyId, isRead }: { jeopardyId: string, isRead: boolean }): Promise<any> => {
        const response = await apiClient.post(`/jeopardy/${jeopardyId}/acknowledgement?is_read=${isRead}`);
        return response.data;
    },

    updateMarkAsClosed: async ({ jeopardyId, paylod }: { jeopardyId: string, paylod: { completion_text: string, action: string } }): Promise<any> => {
        const response = await apiClient.put(`/jeopardy/${jeopardyId}`, paylod);
        return response.data;
    }

};

export const jeopardyReminderApi = {

    fetchReminders: async (jeopardyId: string | undefined): Promise<any> => {
        const response = await apiClient.get(`/jeopardy/${jeopardyId}/reminder`);
        return response.data;
    },

    createReminder: async (payload: {
        "jeopardy_id": string;
        "reminder_title": string;
        "reminder_date": string;
    }): Promise<any> => {
        const response = await apiClient.post(`/jeopardy/reminder`, payload);
        return response.data;
    },

    updateReminder: async ({
        reminderId,
        payload,
    }: {
        reminderId: string;
        payload: {
            "jeopardy_id": string;
            "reminder_title": string;
            "reminder_date": string;
            "is_completed": boolean;
        };
    }): Promise<any> => {
        const response = await apiClient.put(`/jeopardy/reminder/${reminderId}`, payload);
        return response.data;
    }

};

export const notifyApi = {

    sendNotify: async (payload: {
        "recipients": { "user_id": any; }[];
        "channels": string[];
        "referenceType": string;
        "reference": string;
    }): Promise<any> => {
        const response = await apiClient.post(`/notification`, payload);
        return response.data;
    }

};